
import React,{Component} from 'react';
import { withRouter } from 'react-router-dom';
import "./header/Header.css" ;
import "../scss/general.css";
import config from "../config";
import refreshlogo from "../components/images/refresh.png";
import cancellogo from "../components/images/cancel.jpg";

import { MDBCard, MDBCardBody, MDBCardText, MDBCardHeader, MDBCardFooter} from 'mdb-react-ui-kit';
//import { Image } from 'react-bootstrap';
import Cookies from 'universal-cookie';
//import BusyModal from './modalwait';
const axios = require("axios");
const cookies = new Cookies();

class News extends Component{

  constructor(props)
  {
      super(props);
      this.state = {input:{},height:innerHeight,ErrMsg:"",logo:refreshlogo}
//      this.handleClick=this.handleClick.bind(this);
  }
  handlerRemove(i,nid){
    config.Newsarraycount=config.Newsarray.length-1
//    this.setState({CountNews:config.Newsarray.length-1});    
    axios({
        method:"post",
        url:cookies.get("phpclass")+"/index.php/user/UpdateNotifications/"+nid+"/"+cookies.get("LoginID"),
        Headers:{"content-type":"multipart/formdata"}
      })
      .then((response)=>{
        if(response.data===1)
        {
          config.Newsarray.splice(i,1);
          config.Newsarraycount=config.Newsarray.length;
        }
      })
  }


  handlereload=()=>{
    document.body.style.cursor="wait";
    this.setState({logo:cancellogo});
    axios({
      method: 'post',
      url: cookies.get("phpclass")+'/index.php/user/GetNotifications/'+cookies.get("LoginID"),
      headers: {'Content-Type': 'multipart/form-data'}
  })
  .then((response)=> {
      document.body.style.cursor="default";
      config.Newsarray = response.data;
      config.Newsarraycount = config.Newsarray.length;
//      this.setState({CountNews:response.data.length,logo:refreshlogo});
      this.setState({logo:refreshlogo});
  })
  }
  handleC(ClaimID,status){
    if(status==="M")
    {
        let input=this.state.input;
        input["ClaimID"] = ClaimID;
        this.setState({input});
        this.props.history.push({
        pathname: '/medicalform',
        data: this.state.input
      })
    }
  }

  render()
    {
      let items = config.Newsarray;
      if(items.length > 0)
      
      {
      return(
          <div className="inner-profile4" >
            {this.state.ErrMsg}
            <div style={{height:"30px",width:"100%",paddingBottom:10}}><a  href="#" onClick={() => {this.handlereload()}} > <img src={this.state.logo} style={{height:"20px",width:"20px",marginLeft:"15px"}} ></img></a>
            {/*<a  href="#" style={{textDecoration:"none"}} onClick={() => {alert("sdafasdf");}} > <span style={{widt:"50px",color:"gray",marginLeft:"35px"}}>archive</span></a>*/}</div>
            <div style={{height:"100%",width:"100%",overflowY:"auto",paddingBottom:0, backgroundColor:"#3d2b1f"}}>
                {items.map((result, i)=>{
                  if(result.ID == null)
                  {
                    return(    
                      <div id={i} >                      
                          <MDBCard style={{ maxWidth: '25rem',minWidth:'25rem',paddingTop:10, backgroundColor:"#3d2b1f",width:"80%",paddingLeft:"10px",paddingRight:"10px"}} >
                            <MDBCardHeader style={{float:"right",paddingTop:3,backgroundColor:"#f1f1f1", opacity: 0.90,height:"30px",color:"black",fontSize:14}}>{result.Title}<a href="#" onClick={() => {let e=document.getElementById(i);e.remove();this.handlerRemove(i,result.N_ID)}} style={{float:"right",paddingTop:"0px",color:"gray"}}>x</a></MDBCardHeader>
                            <MDBCardBody style={{paddingTop:5}}>
                              <MDBCardText><span style={{fontSize:"9pt",fontWeight:"normal"}}>{result.Body}</span>
                              </MDBCardText>
                            </MDBCardBody>
                            <MDBCardFooter style={{height:20,paddingBottom:3,paddingTop:0}}>
                              <span style={{float:"right",fontSize:"8pt"}}>{result.R_Date}</span>
                            </MDBCardFooter>
                          </MDBCard>
{/*}                          <hr/>*/}
                      </div>  
                      );
                  }
                  else
                  {
                    return(    
                      <div id={i} >                      
                      <MDBCard style={{ maxWidth: '25rem',minWidth:'25rem', backgroundColor:"#3d2b1f",paddingTop:10,width:"80%",paddingLeft:"10px",paddingRight:"10px"}}  >
                        <MDBCardHeader style={{float:"right",paddingTop:5,backgroundColor:"#f1f1f1", opacity: 0.90,height:"30px",color:"black",fontSize:14}}>{result.Title}<a href="#" style={{float:"right",paddingTop:"0px",color:"gray"}} onClick={() => {let e=document.getElementById(i);e.remove();this.handlerRemove(i,result.N_ID)}}>x</a></MDBCardHeader>
{/*}                        <MDBCardImage src='https://mdbcdn.b-cdn.net/img/new/standard/nature/184.jpg' position='top' alt='...' />*/}
                        <MDBCardBody style={{paddingTop:2}}>
{/*}                              <MDBCardTitle><span style={{fontSize:"10pt",fontWeight:"bold"}}>{result.Title}</span><a onClick={() => {this.handledelete(i,result.N_ID)}}  style={{width:"15px", float:"right",marginTop:"-5px",color:"black",fontSize:"8pt",cursor:"default"}}>X</a>
{/*}                          <MDBCardTitle><span style={{fontSize:"10pt",fontWeight:"bold"}}>{result.Title}</span><a href="void(0);" onClick={() => {let e=document.getElementById(i);e.remove();this.props.handler(i,result.N_ID)}}  style={{width:"15px", float:"right",marginTop:"-5px",color:"black",fontSize:"8pt",cursor:"default"}}>X</a>*/}
{/*}                          <MDBCardTitle><span style={{fontSize:"10pt",fontWeight:"bold"}}>{result.Title}</span><a href="void(0);" onClick={() => {let e=document.getElementById(i);e.remove();this.props.handler(i,result.N_ID)}}  className="anchor">X</a>
                          </MDBCardTitle>
                    */}                          
                          <MDBCardText><span style={{fontSize:"9pt",fontWeight:"normal"}}>
                              {result.Body}
                              </span>                             
                              <span style={{float:"right",paddingTop:10,fontSize:"8pt",fontWeight:"normal",cursor:"default", color:"white"}}><button className="anchor" onClick={()=>{this.handleC(result.ID,result.Status)}} >Click here</button></span>
                          </MDBCardText>
                        </MDBCardBody>
                        <MDBCardFooter style={{height:20,paddingBottom:3,paddingTop:0}}>
                          <span style={{float:"right",fontSize:"8pt"}}>{result.R_Date}</span>
                        </MDBCardFooter>
                      </MDBCard>
{/*}                      <hr/>*/}

                      </div>
                  );


                  }
                })}     
            </div>
            </div>
      )
    }
    }
  }  
  
export default withRouter(News);